<button *ngIf="type === 'icon'" type="button" mat-icon-button color="primary" aria-label="View" [matTooltip]="'View'"
	matTooltipPosition="above" (click)="openDialog()">
	<mat-icon>{{icon}}</mat-icon>
</button>
<button *ngIf="type === 'string'" type="button" mat-button color="primary" aria-label="View" [matTooltip]="'View'"
	matTooltipPosition="above" (click)="openDialog()" class="display-text-button">
	<span>{{displayText}}</span>
</button>